/**
 * INHUE 嶼容美學 — Website Content
 * =================================
 * All website content organized by page and section.
 * To update any text on the site, modify the relevant
 * section below and rebuild.
 *
 * IMAGE PLACEHOLDERS:
 * Replace any `image: "/images/..."` path with your actual image.
 * Place image files in the /public/images/ folder.
 */

const content = {
  /* ==================================================
   * GLOBAL / BRAND
   * ================================================== */
  global: {
    siteName: "INHUE 嶼容美學",
    siteNameShort: "INHUE",
    logo: "/images/logo.png", // ← Place your logo in public/images/logo.png
    address: "大安區潮州街",
    email: "inhueaesthetics@gmail.com",
    line: {
      handle: "@560hqugo",
      url: "https://line.me/R/ti/p/@560hqugo",
    },
    instagram: {
      handle: "@inhue.tw",
      url: "https://www.instagram.com/inhue.tw",
    },
  },

  /* ==================================================
   * NAVIGATION
   * ================================================== */
  navigation: {
    links: [
      { label: "首頁", path: "/" },
      { label: "品牌介紹", path: "/about" },
      { label: "服務項目", path: "/services" },
      { label: "作品集", path: "/portfolio" },
      { label: "課程介紹", path: "/courses" },
      // { label: "常見問答", path: "/faq" },
      { label: "聯絡我們", path: "/contact" },
    ],
    cta: { label: "預約諮詢", path: "/contact" },
  },

  /* ==================================================
   * PAGE 1: HOME (首頁)
   * ================================================== */
  home: {
    hero: {
      headingBrand: "INHUE",
      headingChinese: "嶼容美學",
      subheading: "每個人，都是一座有色調的島嶼",
    },

    intro: {
      paragraphs: [
        "有時候您不需要改變什麼，只要讓自己更像自己",
        "我一直相信，\u2002美不是改變一個人，\n而是讓他在鏡子裡，\u2002看見自己原本就有的樣子。",
        "這個空間的誕生，不是為了快速，而是為了穩定；\n不是追求流行，而是適合。",
      ],
    },

    atmosphere: {
      heading: "讓人安心的美",
      body: "在適合裡，慢慢變好\n由內而外看見自己，獨立而不孤立，融合而不混雜。\n一個以穩定、安全、適合為前提的美學空間",
    },

    philosophy: {
      heading: "我們不追求完美的改造，只追求最剛好的和諧。",
      body: "在 INHUE，容貌不是修飾，\n而是被理解之後，自然顯現的狀態",
    },

    quickServices: {
      heading: "眉・眼・唇・髮",
      subheading: "個人化設計與修復服務",
      description: "為每一張臉，找到適合它的比例與節奏。",
    },
  },

  /* ==================================================
   * PAGE 2: ABOUT US (品牌介紹)
   * ================================================== */
  about: {
    founder: {
      sectionLabel: "創辦人介紹",
      name: "芮熙老師",
      image: "/images/founder.jpg", // ← Place founder photo in public/images/founder.jpg
      bio: [
        "曾任室內設計師，擅長比例與美感融合。後轉入紋繡領域，以\u201C簡單、精緻、融合\u201D為核心。",
        "相信每個人都有獨特的氣場與頻率，而美，應該是從內在自然流動與外在和諧融合的結果。",
      ],
    },

    credentials: {
      sectionLabel: "專業資歷",
      items: [
        "2026 國際紋繡十大名師",
        "2026 中華奧林匹克國際美業大賽 - 監察委員",
        "2024 亞洲國際美容美髮技能大賽宸汐盃 - 廈門站評審",
        "2024 中華奧林匹克國際美業大賽 - 評審",
        "2024 ISO 17024 第一屆國家監察委員",
        "世界美業交流協會理事",
        "榮獲 2026 中華奧林匹克盃半永久唇部 冠軍",
        "榮獲 2026 中華奧林匹克盃半永久眼部 亞軍",
        "榮獲 2026 中華奧林匹克盃半永久眉部 優勝",
        "榮獲 2024 ABHE 亞洲競技大賽半永久眉部 季軍",
        "榮獲 2024 ABHE 亞洲競技大賽半永久眼線 優勝",
        "榮獲 2024 INCA 國際盃紋繡競賽眼部 殿軍",
        "榮獲 2024 INCA 國際盃紋繡競賽 佳作",
        "榮獲 2023 中華奧林匹克盃半永久紋繡 亞太創作獎",
        "韓國 WSBF 世界皮膚美容協會半永久證照",
        "韓國 IFBC 半永久國際證照",
        "韓國 SISA 皮膚管理國際證照",
        "韓國 KPMF 醫學皮膚管理國際證照",
        "英國 CIBTAC 國際美容證照",
      ],
    },

    manifesto: {
      sectionLabel: "品牌宣言",
      blocks: [
        {
          heading: null,
          body: "有時候您不需要改變什麼，只要讓自己更像自己\n我一直相信，\u2002美不是改變一個人，\n而是讓他在鏡子裡，\u2002看見自己原本就有的樣子。\n這個空間的誕生，不是為了快速，而是為了穩定；\n不是追求流行，而是適合。",
        },
        {
          heading: "讓人安心的美",
          body: "在適合裡，慢慢變好\n由內而外看見自己，獨立而不孤立，融合而不混雜。\n一個以穩定、安全、適合為前提的美學空間",
        },
        {
          heading: "我們不追求完美的改造，只追求最剛好的和諧。",
          body: "在 INHUE，容貌不是修飾，\n而是被理解之後，自然顯現的狀態",
        },
        {
          heading: "眉・眼・唇・髮",
          body: "個人化設計與修復服務\n為每一張臉，找到適合它的比例與節奏。",
        },
      ],
    },
  },

  /* ==================================================
   * PAGE 3: SERVICES (服務項目)
   * ================================================== */
  services: {
    categories: [
      {
        id: "brows",
        title: "【眉部設計 | 容眉系列】",
        slogan: "「有時候，你不需要改變什麼，只要讓自己更像自己」",
        description:
          "以骨架比例與毛流走向為基礎，在霧的柔與線的形之間取得剛剛好的平衡。我們不複製範本，只為您設計屬於您的眉。",
        items: [
          {
            slug: "soft-mist-brow",
            name: "柔霧容眉 | 乾淨柔焦、自然無痕",
            description:
              "薄結痂，零修復感的新技術，運用雙色慢慢打造輕盈柔霧，猶如眉粉掃畫的細膩質感。適合想維持乾淨氣質、自然妝感者。",
            note: "真正好看的眉，不會讓人驚艷，而是讓人覺得妳變得安靜、穩了。",
            image: "/images/services/soft-mist-brow.jpg",
          },
          {
            slug: "fusion-brow",
            name: "融線容眉 | 霧線融合、立體自然",
            description:
              "結合飄線與霧化設計，柔中帶形、形中帶氣。適合希望眉型更立體、輪廓更明確的您。",
            note: "霧與線，不是風格的選擇題，而是設計師根據您特質找到的剛剛好。",
            image: "/images/services/fusion-brow.jpg",
          },
          {
            slug: "brow-consultation",
            name: "眉型設計諮詢體驗",
            description:
              "一次完整分析臉部比例與氣質走向，模擬設計方案，讓您在操作前就能看見適合自己的樣子。",
            note: "您會發現，當有人願意花時間看懂您的臉，您會重新喜歡自己。",
            image: "/images/services/brow-consultation.jpg",
          },
          {
            slug: "brow-color-release",
            name: "眉色釋放調整 | 無創除色",
            description:
              "全新技術安全、不傷皮膚毛囊、不流血。施作次日即可上妝。此技術的靈活性允許日後進行紋繡修改。藍灰眉、橘紅眉或眉型的改善均能有效處理。",
            note: null,
            image: "/images/services/brow-color-release.jpg",
          },
        ],
      },
      {
        id: "eyes",
        title: "【眼部設計 | 留光系列】",
        slogan: "「當眼神有光，語氣都會變溫柔。」",
        description:
          "我們留下的不是線條，而是視線的方向。一點光、一點神，恰到好處地存在。",
        items: [
          {
            slug: "misty-eyeliner",
            name: "留光霧 | 微醺眼霧",
            description:
              "不強調濃度，而是為眼神留一點柔焦。黑棕到棕的自然漸層，讓視線更深邃，也更輕盈。",
            note: null,
            image: "/images/services/misty-eyeliner.jpg",
          },
          {
            slug: "deep-eyeliner",
            name: "留光線 | 深邃眼線",
            description:
              "睜眼有神、閉眼無痕，適合喜歡淡妝或素顏、追求自然的人群。",
            note: null,
            image: "/images/services/deep-eyeliner.jpg",
          },
        ],
      },
      {
        id: "lips",
        title: "【唇部設計】",
        slogan: "「氣色，不是化出來的，是心安後自然浮現的顏色」",
        description:
          "唇色會退，但真正屬於您的那抹色，會留下。美更不是瞬間，而是時間走過後的真實顯現。",
        items: [
          {
            slug: "petal-lips",
            name: "生色唇 | 花瓣暈染唇",
            description:
              "透過精準分析唇部的底層結構，以全新柔霧暈染技法調整底色、有效改善暗沉，讓素顏時也帶有生命氣息與粉嫩光澤。",
            note: null,
            image: "/images/services/petal-lips.jpg",
          },
          {
            slug: "lip-restoration",
            name: "回歸 | 唇色回歸設計",
            description:
              "紋唇顏色過深、發灰、發紫、不均等狀況，以安全節奏調整色素基底，讓唇色慢慢回到自然位置。此服務著重修復與回歸，而非立即上色。",
            note: null,
            image: "/images/services/lip-restoration.jpg",
          },
        ],
      },
      {
        id: "hair",
        title: "【髮際線與頭皮設計】",
        slogan: "「形完整了，氣就安了」",
        description:
          "頭髮是形的延伸，也是能量的邊界。當輪廓穩了，人也跟著安定下來。",
        items: [
          {
            slug: "smp-hairline",
            name: "生息線 | 韓式正統 SMP 紋髮",
            description:
              "以密度設計修飾頭型與髮際線，讓輪廓收束、比例平衡，氣場更穩定。採先進技術在頭皮的毛囊淺層精心打造仿真毛囊，營造出視覺上自然而茂密的髮量感。此方法不會損害真實毛囊，亦不妨礙頭髮的自然生長。",
            note: null,
            image: "/images/services/smp-hairline.jpg",
          },
          {
            slug: "scalp-therapy",
            name: "育息線 | 科技蘊髮",
            description:
              "蘊髮及養髮不是療程，而是一場與自己氣息的對話。看得見的之外，我們也照顧您看不見的地方。一種前沿生物技術。含有豐富的生長因子，這些分子能夠深入頭皮，激活毛囊細胞的再生能力。",
            note: null,
            image: "/images/services/scalp-therapy.jpg",
          },
        ],
      },
    ],
  },

  /* ==================================================
   * PORTFOLIO (作品集)
   * Each service item gets 6 photo slots.
   * Replace placeholder paths with your actual images
   * in public/images/portfolio/<slug>/1.jpg ... 6.jpg
   * ================================================== */
  portfolio: {
    heading: "作品集",
    subheading: "每一件作品，都是一段被理解後的故事。",
    items: [
      {
        slug: "soft-mist-brow",
        name: "柔霧容眉",
        category: "眉部設計",
        images: [
          "/images/portfolio/soft-mist-brow/1.jpg",
          "/images/portfolio/soft-mist-brow/2.jpg",
          "/images/portfolio/soft-mist-brow/3.jpg",
          "/images/portfolio/soft-mist-brow/4.jpg",
          "/images/portfolio/soft-mist-brow/5.jpg",
          "/images/portfolio/soft-mist-brow/6.jpg",
        ],
      },
      {
        slug: "fusion-brow",
        name: "融線容眉",
        category: "眉部設計",
        images: [
          "/images/portfolio/fusion-brow/1.jpg",
          "/images/portfolio/fusion-brow/2.jpg",
          "/images/portfolio/fusion-brow/3.jpg",
          "/images/portfolio/fusion-brow/4.jpg",
          "/images/portfolio/fusion-brow/5.jpg",
          "/images/portfolio/fusion-brow/6.jpg",
        ],
      },
      {
        slug: "brow-consultation",
        name: "眉型設計諮詢體驗",
        category: "眉部設計",
        images: [
          "/images/portfolio/brow-consultation/1.jpg",
          "/images/portfolio/brow-consultation/2.jpg",
        ],
      },
      {
        slug: "brow-color-release",
        name: "眉色釋放調整",
        category: "眉部設計",
        images: [],
      },
      {
        slug: "misty-eyeliner",
        name: "留光霧 | 微醺眼霧",
        category: "眼部設計",
        images: [
          "/images/portfolio/misty-eyeliner/1.jpg",
          "/images/portfolio/misty-eyeliner/2.jpg",
          "/images/portfolio/misty-eyeliner/3.jpg",
          "/images/portfolio/misty-eyeliner/4.jpg",
        ],
      },
      {
        slug: "deep-eyeliner",
        name: "留光線 | 深邃眼線",
        category: "眼部設計",
        images: [
          "/images/portfolio/deep-eyeliner/1.jpg",
        ],
      },
      {
        slug: "petal-lips",
        name: "生色唇 | 花瓣暈染唇",
        category: "唇部設計",
        images: [
          "/images/portfolio/petal-lips/1.jpg",
          "/images/portfolio/petal-lips/2.jpg",
          "/images/portfolio/petal-lips/3.jpg",
          "/images/portfolio/petal-lips/4.jpg",
          "/images/portfolio/petal-lips/5.jpg",
          "/images/portfolio/petal-lips/6.jpg",
        ],
      },
      {
        slug: "lip-restoration",
        name: "回歸 | 唇色回歸設計",
        category: "唇部設計",
        images: [
          "/images/portfolio/lip-restoration/1.jpg",
        ],
      },
      {
        slug: "smp-hairline",
        name: "生息線 | 韓式正統 SMP 紋髮",
        category: "髮際線與頭皮設計",
        images: [
          "/images/portfolio/smp-hairline/1.jpg",
          "/images/portfolio/smp-hairline/2.jpg",
          "/images/portfolio/smp-hairline/3.jpg",
          "/images/portfolio/smp-hairline/4.jpg",
        ],
      },
      {
        slug: "scalp-therapy",
        name: "育息線 | 科技蘊髮",
        category: "髮際線與頭皮設計",
        images: [
          "/images/portfolio/scalp-therapy/1.jpg",
          "/images/portfolio/scalp-therapy/2.jpg",
        ],
      },
    ],
  },

  /* ==================================================
   * PAGE 4: COURSES (課程介紹)
   * ================================================== */
  courses: {
    teaching: {
      sectionLabel: "教學理念",
      heading: "INHUE 教學系統",
      subheading: "不是教你做得更快，而是教你怎麼判斷，什麼才適合",
      blocks: [
        {
          heading: "為什麼我選擇教學",
          body: "很多技術，其實不是做不到，\n而是不知道「什麼時候該做、什麼時候不該做」。\n\n我選擇教學，\n不是為了複製一樣的作品，\n而是希望學員能建立自己的判斷力，\n知道如何為不同的人，做出不同的選擇。\n\n從零開始，把地基打穩。\n不是急著做得像，而是慢慢做得對。",
        },
        {
          heading: "我們怎麼教",
          body: "很多人以為學紋繡，\n是先學技術、再談美感。\n但實際上，\n如果沒有結構觀念與判斷力，\n技術只會變成反覆修補的工具。\n\nINHUE 的教學，\n不論你是剛接觸，或已經有基礎，\n都會先從「理解」開始，\n再進入操作。",
        },
        {
          heading: "課程方向說明",
          body: "我們的課程設計，是為了讓學員知道：\n為什麼要這樣做\n什麼情況不該做\n如何依不同條件調整方式\n\n技術不是照做，而是選擇。",
        },
        {
          heading: "課程形式",
          body: "課程以小班或一對一方式進行，\n依學員狀態與需求調整內容節奏。\n不定期開課，以品質與學習效果為優先。",
        },
      ],
    },

    courseList: {
      sectionLabel: "課程列表",
      items: [
        {
          slug: "wild-brow",
          name: "機器野生眉專修班",
          description:
            "突破傳統生硬線條的排列，做出屬於自己的DNA原生態毛流。並教會你學習線條如何協調，這門課會教你怎麼判斷。",
          images: [
            "/images/courses/wild-brow/1.jpg",
            "/images/courses/wild-brow/2.jpg",
            "/images/courses/wild-brow/3.jpg",
            "/images/courses/wild-brow/4.jpg",
            "/images/courses/wild-brow/5.jpg",
            "/images/courses/wild-brow/6.jpg",
          ],
        },
        {
          slug: "petal-lip-course",
          name: "花瓣暈染唇",
          description:
            "從唇部結構、底色判斷開始，理解如何讓唇色自然呈現，而非追求一次完成的飽和效果。",
          images: [
            "/images/courses/petal-lip-course/1.jpg",
            "/images/courses/petal-lip-course/2.jpg",
            "/images/courses/petal-lip-course/3.jpg",
            "/images/courses/petal-lip-course/4.jpg",
            "/images/courses/petal-lip-course/5.jpg",
            "/images/courses/petal-lip-course/6.jpg",
          ],
        },
        {
          slug: "misty-eye-course",
          name: "微醺眼霧",
          description:
            "以「柔霧漸層」為核心的眼部設計課程。學習如何讓眼線不銳利、不厚重，而是自然地為眼神留一點光與深度。",
          details: {
            focus: [
              "眼型與睫毛根部結構判斷",
              "黑棕至棕色的漸層控制",
              "線感與霧感的取捨與安全界線",
            ],
            suitableFor:
              "適合零基礎學員，也適合已會眼線、但希望作品更耐看、更細緻的操作者。",
          },
          images: [
            "/images/courses/misty-eye-course/1.jpg",
            "/images/courses/misty-eye-course/2.jpg",
            "/images/courses/misty-eye-course/3.jpg",
            "/images/courses/misty-eye-course/4.jpg",
            "/images/courses/misty-eye-course/5.jpg",
          ],
        },
        {
          slug: "snow-mist-brow",
          name: "機器雪霧眉",
          description:
            "從零開始理解霧眉的本質，包含機器操作、層次控制與自然留色概念。適合零基礎或希望霧感更乾淨的學員。",
          images: [
            "/images/courses/snow-mist-brow/1.jpg",
            "/images/courses/snow-mist-brow/2.jpg",
            "/images/courses/snow-mist-brow/3.jpg",
            "/images/courses/snow-mist-brow/4.jpg",
            "/images/courses/snow-mist-brow/5.jpg",
            "/images/courses/snow-mist-brow/6.jpg",
          ],
        },
        {
          slug: "full-program",
          name: "眉眼唇全科班",
          description: null,
          includes: [
            {
              name: "機器雪霧眉",
              description:
                "從零開始理解霧眉的本質，包含機器操作、層次控制與自然留色概念。適合零基礎或希望霧感更乾淨的學員。",
            },
            {
              name: "微醺眼霧",
              description:
                "以「柔霧漸層」為核心的眼部設計課程。學習如何讓眼線不銳利、不厚重，而是自然地為眼神留一點光與深度。本課程著重於：眼型與睫毛根部結構判斷、黑棕至棕色的漸層控制、線感與霧感的取捨與安全界線。適合零基礎學員，也適合已會眼線、但希望作品更耐看、更細緻的操作者。",
            },
            {
              name: "花瓣暈染唇",
              description:
                "從唇部結構、底色判斷開始，理解如何讓唇色自然呈現，而非追求一次完成的飽和效果。",
            },
          ],
          images: [
            "/images/courses/full-program/1.jpg",
            "/images/courses/full-program/2.jpg",
            "/images/courses/full-program/3.jpg",
            "/images/courses/full-program/4.jpg",
            "/images/courses/full-program/5.jpg",
            "/images/courses/full-program/6.jpg",
          ],
        },
      ],
    },
  },

  /* ==================================================
   * PAGE 5: FAQ (常見問答)
   * ================================================== */
  faq: {
    heading: "常見問答",
    subheading: "此區塊即將更新，敬請期待。",
    items: [],
  },

  /* ==================================================
   * PAGE 6: CONTACT (聯絡我們)
   * ================================================== */
  contact: {
    heading: "聯絡我們",
    subheading: "歡迎預約諮詢，讓我們為您找到最適合的方案。",
    details: [
      { label: "地址", value: "大安區潮州街" },
      { label: "Email", value: "inhueaesthetics@gmail.com" },
      { label: "LINE", value: "@560hqugo", url: "https://line.me/R/ti/p/@560hqugo" },
      { label: "Instagram", value: "@inhue.tw", url: "https://www.instagram.com/inhue.tw" },
    ],
  },

  /* ==================================================
   * FOOTER
   * ================================================== */
  footer: {
    copyright: "© 2020–2026 INHUE 嶼容美學. All rights reserved.",
  },
};

export default content;
